export const globalMixin = {
    methods: {
        formatMoney: function (money) {
            return money.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        },

        returnUrl: function (link) {
            return this.$store.getters.returnUrl(link)
        },

        returnVirtualUrl: function (link) {
            return this.$store.getters.returnVirtualUrl(link)
        }
    }
}